import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import './Contact.css';

const Contact = () => {

    const { register, handleSubmit, reset } = useForm();
    const [formLoad, setFormLoad] = useState(false);

    const onSubmit = data => {
        setFormLoad(true)
        fetch('https://shrouded-waters-85119.herokuapp.com/contact', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
        .then(res => res.json())
        .then(data => {
            if(data.messageId){
                setFormLoad(false)
                Swal.fire({
                    title: 'Message Send Successfully',
                    confirmButtonText: 'Close',
                    confirmButtonColor: '#4831d4',
                })
                reset();
            }
        });
    };
    

    return (
        <>
            <section id="contact">
                <div className="container">
                    <div className="section__header text-center">
                        <h2 className="section__title">Send me a message!</h2>
                        <p className="section__subtitle">
                            Got a question or proposal, or just want 
                            <br />
                            to say hello? Go ahead.
                        </p>
                    </div>
                    <div className="contact__form">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="form__grid">
                                <div className="form__group">
                                    <input type="text" {...register("yourName")} placeholder="Enter your name" required />
                                </div>
                                <div className="form__group">
                                    <input type="email" {...register("yourEmail")} placeholder="Enter your email" required />
                                </div>
                            </div>
                            <div className="form__full">
                                <textarea {...register("yourMessage")} cols="30" rows="2" placeholder="Hi, Are you want me to develop a website for you? Let's discuss it!" required></textarea>
                            </div>
                            <div className="form__btn">
                                <button disabled={formLoad} className={`${formLoad ? 'form__load' : 'btn__brand'}`}>
                                    Shoot 
                                    {
                                        formLoad ?
                                        <Spinner animation="border" className='spinner__border' />
                                        :
                                        <span> &rarr;</span>
                                    }
                                    
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Contact;